import React from "react";
import "../styles/FlowchartDesign.css";

// Import icons (adjust the paths as per your assets folder)
import userIcon from "../../../../assets/solutions/edcato/user.svg";
import dashboardIcon from "../../../../assets/solutions/edcato/dashboard.svg";
import classroomIcon from "../../../../assets/solutions/edcato/classroom.svg";
import moneyIcon from "../../../../assets/solutions/edcato/money.svg";
import academicIcon from "../../../../assets/solutions/edcato/academic.svg";
import conversationIcon from "../../../../assets/solutions/edcato/conversation.svg";
import monitorIcon from "../../../../assets/solutions/edcato/monitor.svg";

const FlowchartDesign = () => {
  const steps = [
    { title: "User Login", description: "Admin, Teacher, Student, Parent", icon: userIcon },
    { title: "Dashboard Overview", description: "Role-specific", icon: dashboardIcon },
    { title: "Student Information Management", description: "Admission, Attendance, Performance", icon: classroomIcon },
    { title: "Fee Management", description: "Payroll, Billing, Payment Tracking", icon: moneyIcon },
    { title: "Academic Management", description: "Course Creation, Assignment, Assessment", icon: academicIcon },
    { title: "Communication Module", description: "Messages, Notifications", icon: conversationIcon },
    { title: "Reporting and Analytics", description: "Analytical graphs, Data-Downloading", icon: monitorIcon },
  ];

  return (
    <section className="flowchart-section">
      <div className="container">
        <div className="section-header">
          <h1>Customer Journey with Edcato</h1>
        </div>

        <div className="timeline">
          <div className="timeline-axis" aria-hidden="true"></div>

          <div className="timeline-steps">
            {steps.map((step, idx) => {
              const positionClass = idx % 2 === 0 ? "up" : "down";
              return (
                <div className={`timeline-step ${positionClass}`} key={idx}>
                  <span className="step-dot" aria-hidden="true"></span>

                  <div className="step-box">
                    {/* Icon */}
                    <img src={step.icon} alt={step.title} className="step-icon" />

                    {/* Title + Description */}
                    <h3 className="step-title">{step.title}</h3>
                    {step.description && (
                      <p className="step-description">{step.description}</p>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FlowchartDesign;
